import ChessGame from "./pages/ChessGame";

export default function App() {
  return (
    <div className="min-h-screen">
      <ChessGame />
    </div>
  );
}
